import { render, staticRenderFns } from "./lists-list.vue?vue&type=template&id=c8fac292&scoped=true"
import script from "./lists-list.vue?vue&type=script&lang=js"
export * from "./lists-list.vue?vue&type=script&lang=js"
import style0 from "./lists-list.vue?vue&type=style&index=0&id=c8fac292&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fac292",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/games/lists-list.vue
// module id = fahL
// module chunks = 0